/* @flow */
// detects if objects share same keys
export default <A: {}, B: {}>(objA: A, objB: B): boolean =>
  Object.keys(objA).length + Object.keys(objB).length !==
  Object.keys({ ...objA, ...objB }).length;
